import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface UnsavedChangesDialogProps {
  open: boolean;
  isNewRoute?: boolean;
  onUseLocal: () => void;
  onDiscard: () => void;
}

export default function UnsavedChangesDialog({ open, isNewRoute, onUseLocal, onDiscard }: UnsavedChangesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onDiscard(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{isNewRoute ? 'Unsaved figure draft found' : 'Unsaved local changes detected'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-muted-foreground">
          <p>
            {isNewRoute 
              ? 'A draft of an unsaved figure was found. You can restore it or start fresh.'
              : 'You have unsaved local changes. Choose how to proceed.'}
          </p>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="secondary" onClick={onDiscard} data-testid="unsaved-discard">
            {isNewRoute ? 'Discard' : 'Discard local'}
          </Button>
          <Button onClick={onUseLocal} data-testid="unsaved-use-local">
            {isNewRoute ? 'Restore draft' : 'Use local version'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}









